import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_SearchArea = _resolveComponent("SearchArea")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppBreadcrumb, { items: _ctx.breadcrumbItems }, null, 8, ["items"]),
      _createVNode(_component_el_row, { class: "align-center" }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Licenses", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "spacer" }, null, -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleClickCreate
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Create license ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_SearchArea, {
        label: "license",
        "pagination-data": _ctx.paginationData,
        headers: _ctx.headers,
        query: _ctx.query,
        loading: _ctx.isLoading,
        onEdit: _ctx.handleClickEdit,
        onDelete: _ctx.handleClickDelete,
        onSearch: _ctx.handleClickSearch,
        onSizeChange: _ctx.handleClickSizeChange,
        onCurrentChange: _ctx.handleClickCurrentChange,
        onSort: _ctx.handleClickSort
      }, {
        searchInputs: _withCtx(() => [
          _createVNode(_component_el_row, {
            gutter: 10,
            class: "app-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { sm: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchQuery.licenseKey,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery.licenseKey) = $event)),
                    clearable: "",
                    placeholder: "License key",
                    class: "mr-4",
                    onChange: _ctx.handleClickSearch
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { sm: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchQuery.organizationName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery.organizationName) = $event)),
                    clearable: "",
                    placeholder: "Organization name",
                    class: "mr-4",
                    onChange: _ctx.handleClickSearch
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                sm: 4,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.searchQuery.isLicensed,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery.isLicensed) = $event)),
                    clearable: "",
                    placeholder: "Is active",
                    class: "mr-4",
                    onClear: _ctx.handleClearLicensed,
                    onChange: _ctx.handleClickSearch
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        label: "active",
                        value: true
                      })),
                      (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        label: "inactive",
                        value: false
                      }))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onClear", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["pagination-data", "headers", "query", "loading", "onEdit", "onDelete", "onSearch", "onSizeChange", "onCurrentChange", "onSort"])
    ]),
    _: 1
  }))
}